import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { signOutStart } from "store/user/user.action";
import { selectCurrentUser } from "store/user/user.selector";

function HeaderUserDropdown() {
  const user = useSelector(selectCurrentUser);
  const dispatch = useDispatch(),
    logOut = () => {
      dispatch(signOutStart());
    };
  // console.log("user: ", user);

  if (user == null) return <></>;
  return (
    <div className="dropdown dropdown-arrow dropdown-end z-30">
      <div
        tabIndex={0}
        role="button"
        className="rounded-btn hover:bg-transparent"
      >
        <div className="flex items-center">
          <div className="me-2 leading-none">
            <span className="text-danger inline-flex items-center justify-center rounded-full h-10 w-10 bg-orange-400/30 capitalize">
              {user.username != null
                ? user.username.charAt(0)
                : user.fullName?.charAt(0)}
            </span>
          </div>
          <div className="lg:flex flex-col items-start gap-2 hidden">
            <p className="font-semibold">{user.username || user.fullName}</p>
          </div>
        </div>
      </div>
      <ul
        tabIndex={0}
        className="menu dropdown-content p-2 shadow bg-white dark:bg-casagray-900 rounded-box w-52 mt-4 z-10"
      >
        <li>
          <Link to={"/dashboard/profile"}>Profile</Link>
        </li>
        <li>
          <Link to={"/dashboard/messages"}>Messages</Link>
        </li>
        <li>
          <span role="button" onClick={logOut}>
            Sign Out
          </span>
        </li>
      </ul>
    </div>
  );
}

export default HeaderUserDropdown;
